import { playerAPI } from "../../api/playerAPI"
import { BaseThunkType, InferActionsTypes } from "../store"
import { SongType } from '../../types/types'

export const GET_SONG_MAP = 'GET_SONG_MAP'
export const UPDATE_SONG_MAP = 'UPDATE_SONG_MAP'
export const PLAYER_RESET = 'PLAYER_RESET'
export const IS_FETCHING = 'IS_FETCHING'

export const actions = {
    getSongAC: (song: SongType) => ({ type: GET_SONG_MAP, song } as const),
    updateSongMapAC: (slice: string, currentTime: number) => ({ type: UPDATE_SONG_MAP, slice, currentTime } as const),
    playerResetAC: () => ({ type: PLAYER_RESET } as const),
    isFetchingAC: (isFetching: boolean) => ({ type: IS_FETCHING, isFetching } as const),
}

export type ActionsTypes = InferActionsTypes<typeof actions>
type ThunkType = BaseThunkType<ActionsTypes>

export const getSongMap = (artist: string, songTitle: string): ThunkType => async dispatch => {
    try {
        dispatch(actions.isFetchingAC(true))
        const song = await playerAPI.getSongAPI(artist, songTitle)
        dispatch(actions.getSongAC(song))
    } catch (e: any) {
        throw e
    } finally {
        dispatch(actions.isFetchingAC(false))
    }
}

export const updateSongMap = (slice: string, currentTime: number): ThunkType => async dispatch => {
    try {
        await dispatch(actions.updateSongMapAC(slice, currentTime))
    } catch (e: any) {
        throw e
    } 
}